export class MyAccountP2PCampaigns{

	#formWrapper;
	#featuredImageData;
	#addedGalleryImages = [];

	constructor() {
		this.#formWrapper = document.querySelector('.campaign-details.p2p-campaign');

		if (this.#formWrapper) {
			this.#watchFields();
			this.#watchFormSubmit();
			this.#watchGalleryImagesRemove();
		}
	}

	#watchFields() {
		this.#formWrapper.addEventListener('change', (event) => {
			if (event.target.matches('.campaign-currency')) {
				const el = event.target;

				const otherAmountLabel = el.closest('form')?.querySelector('label.campaign_goal_other_amount-label');
				const goal = el.closest('form')?.querySelector('select[name="campaign_goal"]');

				const currency = el.value.toLowerCase();

				const icon = otherAmountLabel?.querySelector('span');

				if (otherAmountLabel && icon) {
					icon.innerHTML = el.options[el.selectedIndex].dataset?.symbol || '';
				}

				if (goal) {
					const options = [...goal.options];

					options.sort(function(a, b) {
						var aValue = parseInt(a.dataset[currency]?.replace(/[^0-9]/g, '') || 0, 10);
						var bValue = parseInt(b.dataset[currency]?.replace(/[^0-9]/g, '') || 0, 10);

						if (a.value === "" || a.value === "unlimited" || a.value === "other" || b.value === "" || b.value === "unlimited" || b.value === "other") {
							return 0;
						}

						return aValue - bValue;
					});


					for (const option of options) {
						if (['unlimited','other',''].includes(option.value)){
							goal.add(option);
							continue;
						}

						if (![undefined,'',null].includes(option.dataset[currency])) {
							option.textContent = option.dataset[currency] + ' - ' + option.value;
						} else {
							option.textContent = option.value;
						}

						goal.add(option)
					}
				}
			}

			if (event.target.matches('.campaign-goal')) {
				const el = event.target;

				const otherWraper = el.closest('form')?.querySelector('.campaign-goal-other-wrapper');

				const other_name = el.closest('form')?.querySelector('input[name="campaign_goal_other_name"]');
				const other_amount = el.closest('form')?.querySelector('input[name="campaign_goal_other_amount"]');

				if (otherWraper) {
					if (el.value === 'other' ) {
						otherWraper.style.display = '';
					} else {
						otherWraper.style.display = 'none';
					}
				}

				if (other_name){
					other_name.required = el.value === 'other'
				}

				if (other_amount){
					other_amount.required = el.value === 'other'
				}

				const checkbox = el.closest('form')?.querySelector('input[type="checkbox"][name="unlimited_goal"]');
				if (checkbox) {
					checkbox.checked = el.value === 'unlimited';
				}
			}

			if (event.target.matches('input[type="checkbox"][name="unlimited_goal"]')) {
				const checkbox = event.target;

				const isUnlimited = checkbox.checked;

				const goal = checkbox.closest('form')?.querySelector('select[name="campaign_goal"]');

				const otherWraper = checkbox.closest('form')?.querySelector('.campaign-goal-other-wrapper');

				if (otherWraper) {
					otherWraper.style.display = 'none';
				}

				if (!goal || !goal.querySelector('option[value="unlimited"]')) return;

				if (isUnlimited) {
					goal.value = 'unlimited';

					goal.setAttribute('disabled', true);

					const preview = goal.closest('.form-group')?.querySelector('.form-field-value.goal');

					if (preview) {
						preview.textContent = goal.options[goal.selectedIndex].textContent;
					}
				} else {
					for (const option of goal.options) {
						if (option.value !== '' && option.value !== 'unlimited' && option.value !== 'other') {
							goal.value = option.value;
							break;
						}
					}

					if (goal.value === 'unlimited') {
						goal.value = '';
					}

					goal.removeAttribute('disabled');

					const preview = goal.closest('.form-group')?.querySelector('.form-field-value.goal');

					if (preview) {
						preview.textContent = preview.dataset?.empty || '';
					}
				}

			}

			if (event.target.matches('input[type="checkbox"][name="campaign_not_has_end"]')){
				const checkbox = event.target;

				const checked = checkbox.checked;

				const endDate = checkbox.closest('form')?.querySelector('input[name=campaign_end]');

				if (!endDate) return;

				endDate.required = !checked;
				endDate.disabled = checked;
			}

			if (event.target.matches('input[type="file"][name="featured_image"]')) {
				const field = event.target,
				 	formGroup = field.closest('.form-group'),
					img = formGroup.querySelector('.campaign_image img'),
					name = formGroup.querySelector('.featured_image_name'),
					metadata = formGroup.querySelector('.featured_image_metadata'),
					imageFile = field.files[0],
					bytes = imageFile?.size;

				if (!imageFile) {
					name.textContent = this.#featuredImageData.name;
					metadata.textContent = this.#featuredImageData.metadata;
					img.src = this.#featuredImageData.imgSrc;
					return;
				}

				if (!this.#featuredImageData) {
					this.#featuredImageData = {
						name: name.textContent,
						metadata: metadata.textContent,
						imgSrc: img.src,
					};
				}

				name.textContent = imageFile.name;
				metadata.textContent = '...×... | ...';

				let fileSize = '0 bytes';

				if (bytes >= 1073741824) {
					fileSize = (bytes / 1073741824).toFixed(2) + ' GB';
				} else if (bytes >= 1048576) {
					fileSize = (bytes / 1048576).toFixed(2) + ' MB';
				} else if (bytes >= 1024) {
					fileSize = (bytes / 1024).toFixed(2) + ' KB';
				} else if (bytes > 1) {
					fileSize = bytes + ' bytes';
				} else if (bytes === 1) {
					fileSize = bytes + ' byte';
				} else {
					fileSize = '0 bytes';
				}


				img.onload = function() {
					const width = this.naturalWidth;
					const height = this.naturalHeight;

					metadata.textContent = `${width}×${height} | ${fileSize}`;
				};

				img.src = URL.createObjectURL(imageFile);

			}

			if (event.target.matches('input[type="file"][name="photos[]"]')) {
				const field = event.target,
					galleryImagesWrapper = field.closest('.form-group')?.querySelector('.camapign_gallery_images'),
					files = [...field.files];

				if (!galleryImagesWrapper || !files) return;

				files.forEach(image => {
					const src = URL.createObjectURL(image),
						imageWrapper = document.createElement('div');
					imageWrapper.classList.add('campaign_image');
					imageWrapper.innerHTML = `
						<img loading="lazy" decoding="async" src="${src}" class="attachment-medium size-medium" alt="${image.name}" data-index="${this.#addedGalleryImages.length}">
						<span class="remove-image">
							<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
							  <path d="M1.33464 11.8327L0.167969 10.666L4.83464 5.99935L0.167969 1.33268L1.33464 0.166016L6.0013 4.83268L10.668 0.166016L11.8346 1.33268L7.16797 5.99935L11.8346 10.666L10.668 11.8327L6.0013 7.16602L1.33464 11.8327Z" fill="black"></path>
							</svg>
						</span>`

					this.#addedGalleryImages.push(image);

					galleryImagesWrapper.append(imageWrapper);
				});

				field.value = '';
			}
		});
	}

	#watchFormSubmit() {
		this.#formWrapper.querySelector('form')?.addEventListener('submit', event => {
			const form = event.target;
			const galleryImages = form.querySelector('input[type="file"][name="photos[]"]');

			if (!galleryImages) return;

			const dataTransfer = new DataTransfer();
			for (const file of this.#addedGalleryImages) {
				dataTransfer.items.add(file);
			}

			galleryImages.files = dataTransfer.files;
		})
	}

	#watchGalleryImagesRemove() {
		this.#formWrapper.addEventListener('click', event => {
			if (event.target.matches('.camapign_gallery_images .campaign_image .remove-image') || event.target.closest('.camapign_gallery_images .campaign_image .remove-image')) {
				const button = event.target.matches('.camapign_gallery_images .campaign_image .remove-image') ? event.target : event.target.closest('.camapign_gallery_images .campaign_image .remove-image')
				const imageWrapper = button.closest('.campaign_image')
				const image = imageWrapper.querySelector('img');
				const camapign_gallery_images = button.closest('.camapign_gallery_images');

				if (!image) {
					imageWrapper.remove();
				}

				let gallery_image_ids_field = camapign_gallery_images.querySelector('input[name="gallery_image_ids"]');

				if (image?.dataset?.id && gallery_image_ids_field) {
					const gallery_image_ids = gallery_image_ids_field?.value?.split(',') || [];

					const index = gallery_image_ids.indexOf(image.dataset.id);

					if (index >= 0 && typeof gallery_image_ids[index] !== 'undefined') {
						gallery_image_ids.splice(index, 1);
						imageWrapper.remove();
					}

					gallery_image_ids_field.value = gallery_image_ids.join(',');

				} else if(image?.dataset?.index && typeof this.#addedGalleryImages[image.dataset.index] !== 'undefined') {
					const index = +image.dataset.index;

					this.#addedGalleryImages.splice(index, 1);

					imageWrapper.remove();

					camapign_gallery_images.querySelectorAll('[data-index]')?.forEach((element, index) => {
						element.dataset.index = index;
					})
				}


			}
		})
	}
}
